








import {Component, Vue} from 'vue-property-decorator';
import {getVersion} from '@/api/versionApi';
import {frontendVersion} from '@/components/frontendVersion';

@Component
export default class Version extends Vue {
  items: any[] = [];

  async created() {
    const data = await getVersion();
    this.items = [
      {name: 'systemApi', version: data['system-api']},
      {name: 'webApi', version: data['web-api']},
      {name: 'frontend', version: frontendVersion},
    ];
  }
}
